module.exports = __webpack_public_path__ + "static/media/dot_5117EE_a.04363956.svg";